export default __webpack_public_path__ + "static/media/icon_credentials.63324711.svg";